// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor {
  cursor: pointer;
}

.subTab-li {
  display: flex;
  position: relative;
}

.subTab-li > i {
  position: absolute;
  right: 4px;
  top: 10px;
  z-index: 99;
  cursor: pointer;
}

.nav-link {
  color: #8f9bb3;
}

.nav-link.active {
  color: #36f;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/xml-sub-tab-ui/xml-sub-tab-ui.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AACF;;AACA;EACE,cAAA;AAEF;;AAAA;EACE,WAAA;AAGF","sourcesContent":[".cursor {\n  cursor: pointer;\n}\n\n.subTab-li {\n  display: flex;\n  position: relative;\n}\n\n.subTab-li > i {\n  position: absolute;\n  right: 4px;\n  top: 10px;\n  z-index: 99;\n  cursor: pointer;\n}\n.nav-link {\n  color: #8f9bb3;\n}\n.nav-link.active {\n  color: #36f;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
